import { render } from "./IdleScreen.vue?vue&type=template&id=1bb95af1&scoped=true"
import script from "./IdleScreen.vue?vue&type=script&lang=js"
export * from "./IdleScreen.vue?vue&type=script&lang=js"

import "./IdleScreen.vue?vue&type=style&index=0&id=1bb95af1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb95af1"]])

export default __exports__